/*!
 * @pixi/filter-outline - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:08:23 UTC
 *
 * @pixi/filter-outline is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */import{Filter as l,utils as i}from"@pixi/core";var s=`attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`,h=`varying vec2 vTextureCoord;
uniform sampler2D uSampler;

uniform float alpha;
uniform vec2 thickness;
uniform vec4 outlineColor;
uniform vec4 filterClamp;

const float DOUBLE_PI = 3.14159265358979323846264 * 2.;

void main(void) {
    vec4 ownColor = texture2D(uSampler, vTextureCoord);
    vec4 curColor;
    float maxAlpha = 0.;
    vec2 displaced;
    for (float angle = 0.; angle <= DOUBLE_PI; angle += \${angleStep}) {
        displaced.x = vTextureCoord.x + thickness.x * cos(angle);
        displaced.y = vTextureCoord.y + thickness.y * sin(angle);
        curColor = texture2D(uSampler, clamp(displaced, filterClamp.xy, filterClamp.zw));
        maxAlpha = max(maxAlpha, curColor.a * alpha);
    }
    float resultAlpha = max(maxAlpha, ownColor.a);
    gl_FragColor = vec4((ownColor.rgb + outlineColor.rgb * (1. - ownColor.a)) * resultAlpha, resultAlpha);
}
`;const r=class extends l{constructor(e=1,t=0,n=.1,o=1){super(s,h.replace(/\$\{angleStep\}/,r.getAngleStep(n))),this._thickness=1,this._alpha=1,this.uniforms.thickness=new Float32Array([0,0]),this.uniforms.outlineColor=new Float32Array([0,0,0,1]),this.uniforms.alpha=o,Object.assign(this,{thickness:e,color:t,quality:n,alpha:o})}static getAngleStep(e){const t=Math.max(e*r.MAX_SAMPLES,r.MIN_SAMPLES);return(Math.PI*2/t).toFixed(7)}apply(e,t,n,o){this.uniforms.thickness[0]=this._thickness/t._frame.width,this.uniforms.thickness[1]=this._thickness/t._frame.height,this.uniforms.alpha=this._alpha,e.applyFilter(this,t,n,o)}get alpha(){return this._alpha}set alpha(e){this._alpha=e}get color(){return i.rgb2hex(this.uniforms.outlineColor)}set color(e){i.hex2rgb(e,this.uniforms.outlineColor)}get thickness(){return this._thickness}set thickness(e){this._thickness=e,this.padding=e}};let a=r;a.MIN_SAMPLES=1,a.MAX_SAMPLES=100;export{a as OutlineFilter};
//# sourceMappingURL=filter-outline.mjs.map
